
<div class="itb-spinner2 {{spinnerType}}">
  <div class="effect-1 effects"></div>
  <div class="effect-2 effects"></div>
  <div class="effect-3 effects"></div>
</div>

<!-- Build 1.5.13 -->